import React from 'react';

import {useMatchMedia} from '@udemy/hooks';
import {useI18n} from '@udemy/i18n';
import {Accordion} from '@udemy/react-reveal-components';
import {Tabs} from '@udemy/react-structure-components';

import {getTabsFixtures, type TabFixture} from './fixtures';
import {MessagingBanner} from './messaging-banner.react-component';
import styles from './tabs-messaging-module.module.less';
import {TABS_VISUAL_CONFIG} from './tabs-visual-config';

const getTabVisual = (trackingId: string) =>
    TABS_VISUAL_CONFIG[trackingId] ?? {backgroundStyle: {}};

const TabPanelContent = ({tab}: {tab: TabFixture}) => (
    <div className={styles.panel}>
        {tab.tiles.map((tile) => (
            <MessagingBanner
                key={tile.trackingId}
                tile={tile}
                visual={getTabVisual(tile.trackingId)}
            />
        ))}
    </div>
);

const TabsAccordion = ({tabs}: {tabs: TabFixture[]}) => (
    <Accordion name="tabs-messaging-module-accordion" toggleBehavior="always-one" showExpandIcon>
        {tabs.map((tab, index) => (
            <Accordion.Panel key={tab.id} title={tab.title} defaultExpanded={index === 0}>
                <TabPanelContent tab={tab} />
            </Accordion.Panel>
        ))}
    </Accordion>
);

export const TabsMessagingModule = () => {
    const {gettext} = useI18n();
    const tabs = getTabsFixtures(gettext);
    const isMobile = useMatchMedia('sm-max');

    return (
        <div className={styles.tabs} data-purpose="tabs-messaging-module">
            {isMobile ? (
                <TabsAccordion tabs={tabs} />
            ) : (
                <Tabs defaultTabId={tabs[0].id}>
                    {tabs.map((tab) => (
                        <Tabs.Tab key={tab.id} id={tab.id} title={tab.title}>
                            <TabPanelContent tab={tab} />
                        </Tabs.Tab>
                    ))}
                </Tabs>
            )}
        </div>
    );
};
